/*eslint-disable no-unused-vars*/

import { createApp } from 'vue'
import Maska from 'maska'
import form from '@/store/form'
import './assets/js/css/ImportCss'
import { Fancybox } from '@fancyapps/ui'
import SwiperSlider from '@/assets/js/Swiper/Swiper'
import NumberItem from '@/assets/js/Number/Item/NumberItem'
import ReviewList from '@/assets/js/Review/List/ReviewList'
import Show from '@/assets/js/Show/Show'
import Toggle from '@/assets/js/Toggle/Toggle'
import Cookie from '@/assets/js/Cookie/Cookie'
import FilterTop from '@/assets/js/Filter/Top/FilterTop'
import FilterToggle from '@/assets/js/Filter/Toggle/FilterTop'
import FilterOpen from '@/assets/js/Filter/Open/FilterOpen'
import Delivery from '@/assets/js/Delivery/Delivery'
import Map from '@/assets/js/Map/Map'
import Faq from '@/assets/js/Faq/Faq'
import ContactTabs from '@/assets/js/Contact/Tabs/ContactTabs'
import AppFormBlock from '@/components/Form/AppFormBlock.vue'
import AppFormPopup from '@/components/Form/AppFormPopup.vue'

// Подключаем глобально jQuery
const $ = window.$ = window.jQuery = require('jquery')

document.addEventListener('DOMContentLoaded', () => {
    Fancybox.bind('[data-fancybox]', {
        mainClass: 'fancybox--popup'
    })

    Fancybox.bind('[data-fancybox-form]', {
        mainClass: 'fancybox---form'
    })

    new SwiperSlider()
    new NumberItem()
    new ReviewList()
    new Show()
    new Toggle()
    new Cookie()
    new FilterTop()
    new FilterToggle()
    new FilterOpen()
    new Delivery()
    new Map()
    new Faq()
    new ContactTabs()

    if(document.getElementById('block--form') != null) {
        createApp({})
            .component('block-form', AppFormBlock)
            .use(Maska)
            .use(form)
            .mount('#block--form')
    }

    if(document.getElementById('block--form-popup') != null) {
        createApp({})
            .component('block-form-popup', AppFormPopup)
            .use(Maska)
            .use(form)
            .mount('#block--form-popup')
    }
})
